module.exports = __webpack_public_path__ + "img/20191112152346829.813018eb.jpg";